// Entra guest accounts are stored as <local>_<domain>#EXT#@<tenant>.onmicrosoft.com.
// Display-only: callers must keep sending/comparing the stored value untouched.
const GUEST_UPN = /^(.+)_([^_@#]+(?:\.[^_@#]+)+)#EXT#@.+$/i;

export function isGuestUpn(value) {
  return typeof value === 'string' && GUEST_UPN.test(value.trim());
}

export function displayEmail(value) {
  if (typeof value !== 'string') return value;
  const v = value.trim();
  const m = GUEST_UPN.exec(v);
  return m ? `${m[1]}@${m[2]}` : v;
}

export default displayEmail;
